<template>
  <template v-if="isLoding">
    <loading :message="'データ読み込み中...'"></loading>
  </template>
  <template v-else>
    <div class="read-list">
      <!-- 会社連絡 -->
      <div class="maininfo">
        <div class="list-container">
          <select-box class="read-select" :options="OptionConst.RENRAKU_SERACH_READ_OPTION" v-model="selected"
            @change="selectChange"></select-box>
          <scroll-table>
            <table>
              <thead>
                <th class="code">社員番号</th>
                <th class="name">氏名</th>
                <th class="date">既読日</th>
              </thead>
              <tbody>
                <tr v-for="item in dispList">
                  <td>{{ item.staff_code }}</td>
                  <td>{{ item.staff_name }}</td>
                  <td>{{ item.read_datetime ? dateFormat(item.read_datetime) : null }}</td>
                </tr>
              </tbody>
            </table>
          </scroll-table>
        </div>
      </div><!-- /maininfo -->
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { dateFormat, timeFormat } from "@/filters/common";
import OptionConst from '@/const/Option';
import { RenrakuReadList } from "@/types/KaisyaRenraku";

export default defineComponent({
  props: {
    list: {
      type: Object as () => RenrakuReadList[],
      require: true,
      default: null
    },
    isLoding: {
      type: Boolean,
      default: true
    },
  },
  setup(props) {
    const selected = ref(OptionConst.RENRAKU_SERACH_READ.ALL)
    const dispList = ref(props.list)

    const selectChange = () => {
      if(!props.list){
        return
      }
      if (selected.value == OptionConst.RENRAKU_SERACH_READ.ALL) {
        dispList.value = props.list
      } else if (selected.value == OptionConst.RENRAKU_SERACH_READ.READ) {
        const tempList = props.list.filter(function (v, k) {
          return v.read_datetime
        })
        dispList.value = tempList
      } else {
        const tempList = props.list.filter(function (v, k) {
          return !v.read_datetime
        })
        dispList.value = tempList
      }
    }

    onMounted(() => {
      // list.value = listData
    })

    return {
      dateFormat,
      timeFormat,
      OptionConst,
      selectChange,
      selected,
      dispList,
    };
  },
  components: {},
});
</script>

<style lang="scss" scoped>
@import '@scss/components/renraku-detail-tab.scss';
</style>
